export default "__VITE_ASSET__vca2ZCe3__"